<template>
  <div class="task_wrap">
    <div class="task_people">
      <div>针对 <span>{{taskChildData.taskName || '-'}}</span> 任务，统计跟踪其发券情况、券核销情况、券贡献加油订单等分析；统计时间：{{taskChildData.startTimeFormat || '-'}}至{{taskChildData.endTimeFormat || '-'}}<span style="color: #808080" v-if="taskChildData.status === 4">(持续更新中)</span></div>
      <div>
        <!-- <el-button size="mini" :disabled="Object.keys(taskDayDataSum).length === 0">下载数据</el-button> -->
         <download-button :otherDisab="isData" :downloadApi="sumDayDataExport" :queryParams="{ ...downloadParamsNotime }" style="margin-right: 10px;" :text="'下载数据'"></download-button>
      </div>
    </div>
    <div class="task_tabs">
      <div class="tabs" style="background: linear-gradient(225deg, #81A5FF 0%, #4B7EFE 100%);">
        <div>
          <span>画像人群总数</span>
          <el-popover placement="top" trigger="hover">
            <div class="pop-container"><div>精准营销活动选中的人群人数数量</div></div>
            <span class="que" slot="reference">?</span>
          </el-popover>
        </div>
        <div><span>{{taskDayDataSum.totalProfileCrowdNum | isNullOr0}}</span><span>人</span></div>
      </div>
      <div class="tabs" style="background: linear-gradient(225deg, #B7C5DC 0%, #8394B3 100%);">
        <div>
          <span>实际发券人数</span>
          <el-popover placement="top" trigger="hover">
            <div class="pop-container"><div>实际发放优惠券人数</div></div>
            <span class="que" slot="reference">?</span>
          </el-popover>
        </div>
        <div><span>{{taskDayDataSum.actualCouponNum | isNullOr0}}</span><span>人</span></div>
      </div>
      <div class="tabs" style="background: linear-gradient(225deg, #ECD39E 0%, #D6A75B 100%);">
        <div>
          <span>实际发券金额</span>
          <el-popover placement="top" trigger="hover">
            <div class="pop-container"><div>实际发放优惠券券面额</div></div>
            <span class="que" slot="reference">?</span>
          </el-popover>
        </div>
        <div><span>{{taskDayDataSum.actualCouponAmount | isNullOr0}}</span><span>元</span></div>
      </div>
      <div class="tabs" style="background: linear-gradient(225deg, #B3B2DA 0%, #7578B4 100%);">
        <div>
          <span>实际发券张数</span>
          <el-popover placement="top" trigger="hover">
            <div class="pop-container"><div>实际发放优惠券券张数</div></div>
            <span class="que" slot="reference">?</span>
          </el-popover>
        </div>
        <div><span>{{taskDayDataSum.actualCouponCnt | isNullOr0}}</span><span>人</span></div>
      </div>
    </div>
    <div class="task_card">
      <div class="card" v-for="(item, index) in list" :key="index">
        <div>
          <span>{{item.name}}</span>
           <el-popover
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div>{{item.explain}}</div>
              </div>
              <span class="que" slot="reference">?</span>
            </el-popover>
        </div>
        <div><span>{{item.value | isNullOr0}}</span><span>{{item.unit}}</span></div>
      </div>
    </div>
    <div class="task_sele">
      <span>时间: </span>
      <el-date-picker
        size="medium"
        style="margin-right: 12px;"
        v-model="valueTime"
        :clearable="false"
        type="daterange"
        range-separator="~"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        @change="handleChangeTime"
        end-placeholder="结束日期">
      </el-date-picker>
      <span>显示设置: </span>
      <el-select class="show_sele" size="medium" v-model="valueSelect" placeholder="请选择" multiple @change="handleChange">
        <el-option
          v-for="(item, index) in listCopy"
          :key="index"
          :label="item.name"
          :value="item.name"
          :disabled="item.check">
        </el-option>
      </el-select>
      <div class="down_img">
        <download-button :otherDisab="isPicData" :downloadApi="dayDataExport" :queryParams="{ ...downloadParams }" style="margin-right: 10px;" :text="'下载数据'"></download-button>
        <el-button size="mini" @click="toImg('taskData', '任务数据日趋势', taskChildData.taskName)" :disabled="dataLine.length === 0">下载图片</el-button>
      </div>
    </div>
    <div class="task_user_pic" v-if="dataLine.length > 0">
      <taskDataPic :id="'taskData'" :data="dataLine" :xData="taskDayDataChange.day"/>
    </div>
    <noDataPic v-else/>
  </div>
</template>
<script>
import { cloneObj } from '@/utils/utils'
import { taskDayDataSum, taskDayData, dayDataExport, sumDayDataExport } from '@/api/vipMarket/userData'
import { mapGetters } from 'vuex'
import noDataPic from './noDataPic'
import mixinDown from './mixin'
import taskDataPic from './taskDataPic'
export default {
  mixins: [mixinDown],
  props:{
    taskDayDataSum: {
      type: Object,
      default: () => {}
    },
    taskDayData: {
      type: Object
    },
    // 选择完营销任务后附带的一堆字段
    taskChildData: {
      type: Object
    },
    isChangeTask: {
      type: Array
    }
  },
  data () {
    return {
      list:[],
      listCopy: [], // 枚举值
      listExplain:[
        '发放优惠券已经核销优惠券的人数',
        '发放优惠券已经核销优惠券的券面额',
        '发放优惠券已经核销优惠券的张数',
        '券发放时间-券核销时间',
        '当前核销的券里面，从发券到核销最快用的时间',
        '当前核销的券里面，从发券到核销最慢用的时间',
        '用券订单加油升数',
        '用券订单加油金额',
        '用券订单加油金额/用券订单加油笔数',
        '用券订单加油笔数',
        '已发放但未使用券金额',
        '已发放但未使用券张数',
        '已发放的券过期的券金额',
        '已发放的券过期的券张数'
      ],
      valueSelect: [], // 选择个数
      valueTime: [], // 选择时间
      dataLine: [], // 渲染的数据
      downloadParams: {}, // 下载数据需要传的参数
      downloadParamsNotime: {}, // 下载汇总数据需要传的参数
      taskDayDataChange: {}, // 整体传过来的渲染数据。 需要替换
      dayDataExport,
      sumDayDataExport,
      pickerOptions: { disabledDate: (time) => this.disabled(time) }
    }
  },
  components: {
    taskDataPic,
    noDataPic
  },
  computed: {
    ...mapGetters(['userInfo']),
    isData () {
      return !this.list[0].value && this.list[0] !== 0
    },
    isPicData () {
      return this.dataLine.length === 0
    }
  },
  // 父组件传过来监听所有的数据
  watch: {
    // 上方汇总数据
    taskDayDataSum: {
      handler (val) {
        const listArray = [
          { value: val.consumedCouponNum, name: '已核销券人数', unit: '人', check: false },
          { value: val.consumedCouponAmount, name: '已核销券金额', unit: '元', check: false },
          { value: val.consumedCouponCnt, name: '已核销券张数', unit: '张', check: false },
          { value: val.couponAvgTime, name: '券平均核销时间', unit: '天', check: false },
          { value: val.couponFastTime, name: '券最快核销时间', unit: '天', check: false },
          { value: val.couponSlowTime, name: '券最迟核销时间', unit: '天', check: false },
          { value: val.couponOilLitre, name: '券贡献加油升数', unit: '升', check: false },
          { value: val.couponOilAmount, name: '券贡献加油金额', unit: '元', check: false },
          { value: val.couponAvgAmount, name: '券平均加油金额', unit: '元', check: false },
          { value: val.couponOilNum, name: '券贡献加油笔数', unit: '笔', check: false },
          { value: val.unconsumeCouponAmount, name: '待核销券金额', unit: '元', check: false },
          { value: val.unconsumeCouponCnt, name: '待核销券张数', unit: '张', check: false },
          { value: val.expiredCouponAmount, name: '已过期券金额', unit: '元', check: false },
          { value: val.expiredCouponCnt, name: '已过期券张数', unit: '张', check: false }]
        listArray.forEach((item, index) => { item.explain = this.listExplain[index] })
        this.list = listArray
        this.listData = cloneObj(listArray)
        this.listCopy = this.listData.filter(item => { return (item.name !== '券最快核销时间' && item.name !== '券最迟核销时间') })
      },
      immediate: true
    },
    // 任务附带字段
    taskChildData: {
      handler (val) {
        this.valueTime = [val.startTimeFormat, val.endTimeFormat]
        this.downloadParams = { gasId: this.userInfo.gasId, taskId: val.id, startDate: val.startTimeFormat, endDate: val.endTimeFormat }
        this.downloadParamsNotime = { gasId: this.userInfo.gasId, taskId: val.id }
      }
    },
    // 渲染数据
    taskDayData: {
      handler (val) {
        this.taskDayDataChange = val
      },
    },
    // 任务改变，所有子页面的下拉框清空
    isChangeTask: {
      handler (val) {
        if (val) {
          this.dataLine = [] // 渲染清空
          this.valueSelect = [] // 选择框清空
        }
      }
    }
  },
  methods: {
    // 禁选时间段
    disabled(time) {
      return time.getTime() < new Date(this.taskChildData.startTimeFormat).getTime() || time.getTime() > new Date(this.taskChildData.endTimeFormat).getTime()
    },
    // 选择时间
    handleChangeTime (val) {
      if (!val) return
      this.dataLine = [] // 渲染清空
      this.valueSelect = [] // 选择框清空
      this.taskDayDataSumApi({ gasId: this.userInfo.gasId, taskId: this.taskChildData.id, startDate: val[0], endDate: val[1] })
      this.taskDayDataApi({ gasId: this.userInfo.gasId, taskId: this.taskChildData.id, startDate: val[0], endDate: val[1] })
      this.downloadParams = { gasId: this.userInfo.gasId, taskId: this.taskChildData.id, startDate: val[0], endDate: val[1] }
      this.downloadParamsNotime = { gasId: this.userInfo.gasId, taskId: this.taskChildData.id }
    },
    // 选择限时个数
    handleChange (val) {
      // 超过5个以后，其他不可以选择
      if (val.length > 4) {
        this.listCopy.forEach(item => { item.check = true })
        for (let i = 0; i<this.listCopy.length; i++) {
          for (let j = 0; j<val.length; j++) {
            if (this.listCopy[i].name === val[j]) {
              this.listCopy[i].check = false
            }
          }
        }
      } else {
        this.listCopy.forEach(item => { item.check = false })
      }
      // this.valueSelect.pop()
      // 渲染的数据先清空
      this.dataLine = []
      // 复制一份数据
      const taskDayDataChangeCopy = cloneObj(this.taskDayDataChange.dayData || [])
      // 双向匹配找到选中的是那几个
      taskDayDataChangeCopy.forEach(item => { delete item.check })
      for (let i = 0; i<taskDayDataChangeCopy.length; i++) {
        for (let j = 0; j<val.length; j++) {
          if (taskDayDataChangeCopy[i].name === val[j]) {
            taskDayDataChangeCopy[i].check = true
          }
        }
      }
      let dayDataFilter = cloneObj(taskDayDataChangeCopy.filter((item) => { return item.check === true }))
      dayDataFilter.forEach(item => {
        item.data = item.dataList
        item.type = 'line'
        item.stack = 'Total'
        delete item.dataList
        delete item.dataType
      })
      this.dataLine = dayDataFilter
      dayDataFilter = []
    },
    // 任务数据非图接口
    async taskDayDataSumApi (params) {
      try {
        const { code, result } = await taskDayDataSum(params)
        if (code !== 200) return
        // this.taskDayDataSum = result
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    },
    // 任务数据（折线图）
    async taskDayDataApi (params) {
      try {
        const { code, result } = await taskDayData(params)
        if (code !== 200) return
        this.taskDayDataChange = result
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style scoped lang="less">
.task_wrap{
  padding: 0 20px 0 20px;
}
.task_people{
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  >div:nth-child(1){
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    >span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3377FF;
    }
  }
  .task_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.task_tabs{
  width: 100%;
  height: 70px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tabs{
    width: 23%;
    height: 74px;
    margin-right: 10px;
    padding: 10px 15px;
    // background: #F8F8F8;
    border-radius: 4px;
    >div:nth-child(1){
      display: flex;
      justify-content: space-between;
      >span:nth-child(1){
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      .que{
        display: block;
        width: 14px;
        height: 14px;
        border:1px solid #fff;
        border-radius: 50%;
        text-align: center;
        line-height: 14px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
      }
    }
    >div:nth-child(2){
      margin-top: 10px;
      >span:nth-child(1){
        margin-right: 4px;
        font-size: 20px;
        font-family: RobotoCondensed-Bold, RobotoCondensed;
        font-weight: bold;
        color: #FFFFFF;
      }
      >span:nth-child(2){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
}
.task_card{
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  .card{
    width: 12.5%;
    min-width: 165px;
    height: 64px;
    margin: 0 10px 10px 0;
    padding: 10px 15px;
    background: #F8F8F8;
    border-radius: 4px;
    >div:nth-child(1){
      display: flex;
      justify-content: space-between;
      >span:nth-child(1){
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .que{
        display: block;
        width: 14px;
        height: 14px;
        border:1px solid #C7C7C7;
        border-radius: 50%;
        text-align: center;
        line-height: 14px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
    >div:nth-child(2){
      margin-top: 10px;
      >span:nth-child(1){
        margin-right: 4px;
        font-size: 20px;
        font-family: RobotoCondensed-Bold, RobotoCondensed;
        font-weight: bold;
        color: #333333;
      }
      >span:nth-child(2){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.task_sele{
  width: 100%;
  height: 50px;
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  >span{
    margin-right: 10px;
  }
  /deep/.el-select__tags {
    position: absolute;
    line-height: normal;
    white-space: normal;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    max-height: 60px;
    overflow: scroll;
  }
  .task_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .down_img{
    position: absolute;
    right: 0;
  }
}
</style>